import http from './ajax';

const API_URL = {
  Register: '/api/Auth/Register', //註冊
  Login: '/api/Auth/Login', //登入
  ResetPassword: '/api/Auth/ResetPassword', //重置密碼
  ForgotPassword: '/api/Auth/ForgotPassword', //忘記密碼
  Logout: '/api/Auth/Logout', //登出
  SendEmail: '/api/Member/SendValidateEmail', //寄驗證信
  UpdateProfile: '/api/Member/UpdateProfile', //更新會員資料
  UpdateFile: '/api/Member/Upload', //上傳檔案
  CheckFile: '/api/Member/RequestAduit', //檢查上傳檔案
  FirstJoin: '/api/Member/JoinMembership', //第一次加入會員
  Renewal: '/api/Member/RenewMembership', //續會
  ActivityOrders: '/api/Member/ActivityOrders', //活動訂單列表
  ActivityQrderDetail: '/api/Member/ActivityOrder', //活動訂單詳細
  ReceiptMember: '/api/Member/ReceiptMember', // 列印會費收據用
  ReceiptActivity: '/api/Member/Receipt' // 列印活動收據
};

class newsApi extends http {
  //登入
  Login = async (params = {}) => {
    try {
      let url = API_URL.Login;
      const response = await this.postRequest(url, params);
      return response;
    } catch (err) {
      console.log('Login', err);
    }
  };
  getLogin = (params = {}) => {
    return this.Login(params);
  };
  //登出
  Logout = async (params = {}) => {
    try {
      let url = API_URL.Logout;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('Logout', err);
    }
  };
  getLogout = (params = {}) => {
    return this.Logout(params);
  };
  //忘記密碼
  ForgotPassword = async (params = {}) => {
    try {
      let url = API_URL.ForgotPassword;
      const response = await this.postforPasswordRequest(url, `"${params.Email}"`);
      return response;
    } catch (err) {
      console.log('ForgotPassword', err);
    }
  };
  getForgotPassword = (params = {}) => {
    return this.ForgotPassword(params);
  };
  //註冊
  Register = async (params = {}) => {
    try {
      let url = API_URL.Register;
      const response = await this.postRequest(url, params);
      return response;
    } catch (err) {
      console.log('ForgotPassword', err);
    }
  };
  getRegister = (params = {}) => {
    return this.Register(params);
  };
  //更換密碼
  ResetPassword = async (params = {}) => {
    try {
      let url = API_URL.ResetPassword;
      const response = await this.postRequest(url, params);
      return response;
    } catch (err) {
      console.log('ResetPassWord', err);
    }
  };
  getResetPassword = (params = {}) => {
    return this.ResetPassword(params);
  };
  //驗證信
  SendEmail = async (params = {}) => {
    try {
      let url = API_URL.SendEmail;
      const response = await this.postRequest(url);
      return response;
    } catch (err) {
      console.log('SendEmail', err);
    }
  };
  getSendEmail = (params = {}) => {
    return this.SendEmail(params);
  };
  //更新會員資料
  UpdateProfile = async (params = {}) => {
    try {
      let url = API_URL.UpdateProfile;
      const response = await this.patchRequest(url, params);
      return response;
    } catch (err) {
      console.log('UpdateProfile', err);
    }
  };
  getUpdateProfile = (params = {}) => {
    return this.UpdateProfile(params);
  };
  //上傳檔案  app,dip,cer,spe
  UpdateFile = async (type, formdata) => {
    try {
      let url = API_URL.UpdateFile + '/' + type;
      const response = await this.postRequest(url, formdata);
      return response;
    } catch (err) {
      console.log('UpdateFile', err);
    }
  };
  getUpdateFile = (type, formdata) => {
    return this.UpdateFile(type, formdata);
  };
  //檢查上傳檔案
  CheckFile = async () => {
    try {
      let url = API_URL.CheckFile;
      const response = await this.postRequest(url);
      return response;
    } catch (err) {
      console.log('CheckFile', err);
    }
  };
  getCheckFile = () => {
    return this.CheckFile();
  };

  //入會囉!!
  JoinTrs = async () => {
    try {
      let url = API_URL.FirstJoin;
      const response = await this.postRequest(url);
      return response;
    } catch (err) {
      console.log('JoinTrs', err);
    }
  };
  getJoinTrs = () => {
    return this.JoinTrs();
  };

  //續會囉!!
  RenewalTrs = async () => {
    try {
      let url = API_URL.Renewal;
      const response = await this.postRequest(url);
      return response;
    } catch (err) {
      console.log('JoinTrs', err);
    }
  };
  getRenewalTrs = () => {
    return this.RenewalTrs();
  };

  //顯示活動訂單列表
  ActivityOrders = async (params = {}) => {
    try {
      let url = `${API_URL.ActivityOrders}?leaf=${params.leaf}&count=${params.count}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('ActivityOrders', err);
    }
  };
  getActivityOrders = (params = {}) => {
    return this.ActivityOrders(params);
  };

  //顯示活動訂單詳細
  ActivityQrderDetail = async (params = {}) => {
    try {
      let url = `${API_URL.ActivityQrderDetail}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('ActivityQrderDetail', err);
    }
  };
  getActivityQrderDetail = (params = {}) => {
    return this.ActivityQrderDetail(params);
  };

  // 列印會費收據
  PrintMember = async () => {
    try {
      let url = `${API_URL.ReceiptMember}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('PrintMember', err);
    }
  };
  getPrintMember = () => {
    return this.PrintMember();
  };

  // 列印活動收據
  PrintActivity = async (params = {}) => {
    try {
      let url = `${API_URL.ReceiptActivity}/${params.Id}`;
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      console.log('PrintActivity', err);
    }
  };
  getPrintActivity = (params = {}) => {
    return this.PrintActivity();
  };
}

export default new newsApi();



// WEBPACK FOOTER //
// ./src/service/member.js